import { runRemoteCommand } from "./Util.ts";
import $ from "jquery";
import { parseNumber, syncCallback } from "@de-xima/xima-common-js-lang";

export async function performPluginUpdateCheck(): Promise<void> {
  if (typeof FacesHttp === "object") {
    FacesHttp?.SocketApi?.onNoneConnecting(
      syncCallback(async () => runRemoteCommand(BackendCommand?.performPluginUpdateCheck)),
    );
  }
}

export function clearIcon(): void {
  const $button = $(".fc-im-button");
  const $buttonIcon = $(".fc-im-button .ui-icon");
  const $badge = $(".fc-im-badge");
  $badge.addClass("fc-im-cleared");
  $button.removeClass("fc-im-active");
  $buttonIcon.removeClass("ui-icon-notifications-active");
  $buttonIcon.addClass("ui-icon-notifications-none");
}

export function updateMessageIcon(): void {
  const $badge = $(".fc-im-badge");
  const $logButton = $(".fc-im-log");
  $logButton.removeClass("fc-im-priority-high fc-im-priority-medium fc-im-priority-low");
  const highPrio = $(".fc-im-entry.fc-im-priority-high");
  const mediumPrio = $(".fc-im-entry.fc-im-priority-medium");
  if (highPrio.length >= 1) {
    $logButton.addClass("fc-im-priority-high");
  } else if (mediumPrio.length >= 1) {
    $logButton.addClass("fc-im-priority-medium");
  } else {
    $logButton.addClass("fc-im-priority-low");
  }
  const badgeText = $badge.text();
  const badgeNumber = parseNumber(badgeText) - 1;
  if (badgeNumber <= 0) {
    clearIcon();
  } else {
    $badge.text(badgeNumber);
  }
}
